import { Fingerprint, ScanLine, Send, ShieldCheck, MapPin, Clock, Users } from "lucide-react";

export const COMPANY = {
  name: "Cayman Fingerprinting Services Ltd.",
  shortName: "Cayman Fingerprinting",
  address: "93 Hospital Rd. SIGMA Building, 1st Floor, George Town, Grand Cayman, Cayman Islands",
  phone: "345-928-0382",
  phoneHref: "tel:+13459280382",
  email: "info@caymanfingerprinting.com",
  emailHref: "mailto:info@caymanfingerprinting.com",
  hours: "Monday \u2013 Friday: 9 AM \u2013 3 PM",
};

export const SERVICES = [
  {
    id: "livescan",
    title: "Live Scan Digital Fingerprinting",
    apiValue: "Live Scan Digital Fingerprinting",
    icon: ScanLine,
    description:
      "Fast, precise digital fingerprint capture with significantly lower rejection rates than traditional ink methods.",
    anchor: "#livescan",
  },
  {
    id: "ink",
    title: "Traditional Ink Fingerprint Cards",
    apiValue: "Traditional Ink Fingerprint Cards",
    icon: Fingerprint,
    description:
      "Professional fingerprint capture printed directly onto FD-258, FD-1164, SF-87, and other approved fingerprint cards.",
    anchor: "#ink",
  },
  {
    id: "fdle",
    title: "FDLE Digital Submissions",
    apiValue: "FDLE Digital Submissions",
    icon: Send,
    description:
      "Secure electronic fingerprint submissions to the Florida Department of Law Enforcement, right here in the Cayman Islands.",
    anchor: "#fdle",
  },
];

export const TRUST_POINTS = [
  { icon: ShieldCheck, title: "Secure & Confidential", desc: "Your personal data is handled with strict confidentiality." },
  { icon: MapPin, title: "Convenient Location", desc: "SIGMA Building, Hospital Rd., George Town." },
  { icon: Clock, title: "30-Minute Appointments", desc: "Quick, efficient service that respects your time." },
  { icon: Users, title: "Experienced Technicians", desc: "Courteous, professional fingerprint specialists." },
];

export const SERVICE_DETAILS = [
  {
    id: "livescan",
    title: "Live Scan Digital Fingerprinting Service",
    items: [
      {
        q: "What are digital Live Scan fingerprint scans?",
        a: "Live Scan digital fingerprint scans are images captured by innovative fingerprint technology that scans your fingerprints electronically for more precise image capture \u2014 no ink required.",
      },
      {
        q: "What are the benefits of digital fingerprinting?",
        a: "Electronic fingerprint scans significantly reduce the likelihood of fingerprint rejections compared with traditional ink methods. The digital format also facilitates faster processing \u2014 fingerprints can be safely printed, saved as an encrypted copy forwarded to the email you provide, or transmitted directly to authorized agencies such as the FBI and the Florida Department of Law Enforcement (FDLE).",
      },
      {
        q: "How long does a Live Scan appointment take?",
        a: "Most Live Scan appointments are completed within your 30-minute booking window. Our experienced technicians make the process quick, comfortable, and accurate.",
      },
    ],
  },
  {
    id: "ink",
    title: "Traditional 'Ink' Fingerprint Cards",
    items: [
      {
        q: "How reliable are images on fingerprint cards?",
        a: "While rejected fingerprint cards used to be a concern in the days of ink-and-roll processing, advancements in fingerprint technology have vastly decreased rejection rates throughout the industry. Our technicians use Live Scan technology to print scanned fingerprints directly onto approved fingerprint cards for the highest quality result.",
      },
      {
        q: "Which fingerprint cards do you support?",
        a: "We support FD-258, FD-1164, and SF-87 fingerprint cards, as well as any other agency-specific or state-specific fingerprint card provided by you.",
      },
      {
        q: "Do I need to bring my own fingerprint card?",
        a: "If the requesting agency has provided you with a specific card, please bring it to your appointment. Standard FD-258 cards are available at our office.",
      },
    ],
  },
  {
    id: "fdle",
    title: "FDLE Digital Submissions",
    items: [
      {
        q: "What is the purpose of an FDLE Digital Submission?",
        a: "Residents outside of Florida often need to submit required documentation through the Florida Department of Law Enforcement (FDLE) to complete transactions such as renewing professional licenses in Florida. Only an authorized vendor of the FDLE can complete these submissions.",
      },
      {
        q: "What is the process for completing an FDLE Digital Submission?",
        a: "The process is simple. Our experienced fingerprint technician captures your fingerprints using Live Scan technology. Once we have your securely encrypted fingerprint captures, we complete the transmission of all relevant information directly to the FDLE. All you need is the Originating Routing Identifier (ORI number) for the requesting agency.",
      },
      {
        q: "How long does this process take?",
        a: "While processing times cannot be guaranteed, results are often ready in as little as 24\u201372 hours.",
      },
    ],
  },
];

export const FAQS = [
  {
    q: "Do I need an appointment?",
    a: "Yes \u2014 we operate by appointment to keep your visit quick and efficient. Appointments are 30 minutes each, Monday through Friday between 9:00 AM and 3:00 PM. You can book directly on this page.",
  },
  {
    q: "What should I bring to my appointment?",
    a: "Please bring a valid government-issued photo ID (passport, driver's license, or voter ID) and any fingerprint cards or agency paperwork related to your submission, including ORI numbers where applicable.",
  },
  {
    q: "If I opt for digital fingerprints, how long is my personal information stored?",
    a: "All information captured by Live Scan technology is kept in a secure, locked environment and destroyed within the legally required timeframe. We treat your personally identifiable information (PII) with the highest levels of confidentiality and security.",
  },
  {
    q: "How many people can book the same time slot?",
    a: "Each 30-minute time slot can accommodate a maximum of 3 bookings. If a slot is full, simply choose another available time.",
  },
  {
    q: "Where are you located?",
    a: "We are located at 93 Hospital Rd., SIGMA Building, 1st Floor, George Town, Grand Cayman, Cayman Islands \u2014 minutes from central George Town.",
  },
  {
    q: "Can I reschedule or cancel my appointment?",
    a: "Of course. Call us at 345-928-0382 or email info@caymanfingerprinting.com and we will be happy to adjust your booking.",
  },
  {
    q: "How long do FDLE submissions take to process?",
    a: "While processing times cannot be guaranteed, FDLE digital submission results are often ready in as little as 24\u201372 hours.",
  },
];
